// extracted by mini-css-extract-plugin
export default {"placeholder":"PlaceholderPage_placeholder__dNc-V","card":"PlaceholderPage_card__uTeLR"};